import {useQuery} from '@apollo/client';
import {useEffect, useState} from 'react';
import {BCP_CHECK_RESULTS} from '../graphql/queries/bcpCheckResultQueries';
import {CheckResultListResponse, CheckResultType} from '../graphql/types/BcpCheckResultTypes';
import {CheckResultFilterState} from '../store/bcpCheckResultListStore';

export interface BcpCheckResultListQueryResult {
    data: CheckResultType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
}

export const useBcpCheckResultListQuery = (
    filters: CheckResultFilterState,
    currentPage: number,
    pageSize: number,
    enabled: boolean,
): BcpCheckResultListQueryResult => {
    const [listData, setListData] = useState<CheckResultType[]>([]);
    const [total, setTotal] = useState(0);

    const {data, loading, refetch} = useQuery<CheckResultListResponse>(BCP_CHECK_RESULTS, {
        variables: {
            filters: {
                jobId: filters.jobId ?? undefined,
                groupKey: filters.groupKey || undefined,
                status: filters.status !== undefined ? filters.status : undefined,
                resultCode: filters.resultCode ?? undefined,
                createTimeFrom: filters.createTimeRange?.[0]?.valueOf() ?? undefined,
                createTimeTo: filters.createTimeRange?.[1]?.valueOf() ?? undefined,
            },
            pageRequest: {page: currentPage, size: pageSize, sortBy: 'id', sortDirection: 'DESC'},
        },
        skip: !enabled,
        // 详情返回时命中缓存不重新查询；显式查询/确认后刷新由调用方 refetch 触发
        fetchPolicy: 'cache-first',
    });

    useEffect(() => {
        const content = data?.bcpCheckResults?.content;
        if (content) setListData(content);
        const rawTotal = data?.bcpCheckResults?.pageInfo?.totalElements;
        if (rawTotal !== undefined && rawTotal !== null) {
            const n = Number(rawTotal);
            if (Number.isFinite(n)) setTotal(Math.max(0, Math.trunc(n)));
        }
    }, [data]);

    return {data: listData, loading, refetch, totalElements: total};
};
